export default "__VITE_ASSET__82005637__"